import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IExplainQuestionUpdateIm } from '../../../api/explain-question-update-im.model';
import { IExplainQuestionResponseVm } from '../../../api/explain-question-response-vm.model';

@Injectable({
  providedIn: 'root'
})
export class ExplainQuestionService {

  private http = inject(HttpClient);

  public updateExplain$(data: IExplainQuestionUpdateIm): Observable<IExplainQuestionResponseVm> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.http.put<IExplainQuestionResponseVm>(environment.webApiUrl + '/ExplainQuestionBase', data, { headers });
  }
}
